import { render } from "./SimpleTreeView.vue?vue&type=template&id=ecb42bbe&scoped=true"
import script from "./SimpleTreeView.vue?vue&type=script&lang=js"
export * from "./SimpleTreeView.vue?vue&type=script&lang=js"

import "./SimpleTreeView.vue?vue&type=style&index=0&id=ecb42bbe&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-ecb42bbe"

export default script